import { Stack } from 'expo-router'
import { PointsToCashForMortgageScreens } from '../screens'

type ExpoStackProps = React.ComponentProps<typeof Stack>

export const PointsToCashForMortgageLayout = ({
  ExpoStackProps,
}: {
  ExpoStackProps: ExpoStackProps
}) => (
  <Stack {...ExpoStackProps} screenOptions={{ headerShown: false }}>
    <Stack.Screen name={PointsToCashForMortgageScreens.PointsToCashForMortgage.Name} />
    <Stack.Screen name={PointsToCashForMortgageScreens.MortgageAddressSelector.Name} />
    <Stack.Screen name={PointsToCashForMortgageScreens.MortgageAddress.Name} />
    <Stack.Screen name={PointsToCashForMortgageScreens.DestinationAccountSelector.Name} />
    <Stack.Screen name={PointsToCashForMortgageScreens.RedemptionConfirmation.Name} />
    <Stack.Screen name={PointsToCashForMortgageScreens.SuccessConfirmation.Name} />
  </Stack>
)
